import { useAmplitude } from '@app/utils/analytics/useAmplitude';
import { cn } from '@app/utils/cn';
import { useTranslation } from 'react-i18next';

import { Link } from '../various/Link';
import { ShareButton } from '../various/ShareButton';

interface Props {
  lookbookName: string;
  shareLookbookUrl: string;
  className?: string;
}

export const LookbookHeaderTitle = ({ lookbookName, shareLookbookUrl, className }: Props) => {
  const { t } = useTranslation(['products']);
  const { trackEvent } = useAmplitude();

  return (
    <div className={cn('flex gap-4', className)}>
      <Link
        to={shareLookbookUrl}
        className="line-clamp-1 break-all body-1"
        onClick={() => trackEvent({ name: 'lookbookPage.banner.link.click' })}
      >
        {lookbookName}
      </Link>
      <ShareButton
        tooltipText={t('products:copy_shareable_link')}
        shareURL={shareLookbookUrl}
        message={t('products:share_button_message')}
        onClick={() => trackEvent({ name: 'lookbookPage.banner.shareButton.click' })}
      />
    </div>
  );
};
